import createLocationModel, { prop } from './lib/create_location_model';

const AgenticCommerce = createLocationModel({
  modelName: 'AgenticCommerce',
  properties: {
    timezone: prop(String).default(''),
  },

  deriveNew(attrs) {
    return AgenticCommerce.create({ ...this, ...attrs });
  },

  getTimezone() {
    return this.timezone;
  },

  statics: {
    breadcrumb: 'Agentic Commerce',
  },
});

export default AgenticCommerce;
